var currentStep = 1;

var cookies = {
    set: function (cname, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var cvalue = value + ((exdays === null) ? "" : "; expires=" + exdate.toUTCString());
        var cookie = cname + "=" + cvalue + "; path=/";
        if (document.location.protocol === 'https:') {
            cookie = cname + "=" + cvalue + "; secure; path=/";
        }
        document.cookie = cookie;
    },
    get: function (cname) {
        var i, x, y, ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");
            if (x === cname) {
                return y;
            }
        }
    },
    remove: function (cname) {
        if (document.cookie !== document.cookie) {
            index = document.cookie.indexOf(cname);
        } else {
            index = -1;
        }
        if (index === -1) {
            document.cookie = cname + "=GONEcbEndCookie; expires=Monday, 19-Aug-1996 05:00:00 GMT; path=/";
        }
    }
};

function getScreenSize() {
    if (cookies.get('scrnhght') === undefined || cookies.get('scrnhght') === '0') {
        var height = $(window).height();
        cookies.set("scrnhght", height, 7);
    }
    if (cookies.get('scrnwdth') === undefined || cookies.get('scrnwdth') === '0') {
        var width = $(window).width();
        cookies.set("scrnwdth", width, 7);
    }
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

$(".digits-only").on("keypress", function (evt) {
    if (evt.which < 48 || evt.which > 57) {
        evt.preventDefault();
    }
});

$(".tel-only").on("keypress", function (evt) {
    if (!((evt.which === 43) || (evt.which > 47 && evt.which < 58))) {
        evt.preventDefault();
    }
});

window.site = {
    uptoXLarge: function () { return ($(window).width() <= 1499) },
    overXLarge: function () { return ($(window).width() >= 1500) },
    uptoLarge: function () { return ($(window).width() <= 1199) },
    overLarge: function () { return ($(window).width() >= 1200) },
    uptoMedium: function () { return ($(window).width() <= 991) },
    overMedium: function () { return ($(window).width() >= 992) },
    uptoSmall: function () { return ($(window).width() <= 767) },
    overSmall: function () { return ($(window).width() >= 768) },
    uptoXSmall: function () { return ($(window).width() <= 479) },
    overXSmall: function () { return ($(window).width() >= 480) }
};


function PostcodeAnywhere_Interactive_Find_v1_10($addressFinder, Key, SearchTerm, PreferredLanguage, Filter, UserName) {
    $.getJSON("https://api.addressy.com/Capture/Interactive/Find/v1.20/json6.ws?callback=?",
        {
            Key: 'XD63-AJ85-CJ94-UW77',
            Text: SearchTerm,
            Language: PreferredLanguage,
            Filters: Filter
        },
        function (data) {

            $results = $addressFinder.find('.address-finder-results');
            $details = $addressFinder.find('.address-finder-details');
            $search = $addressFinder.find('.address-finder-search');
            $errorWrapper = $addressFinder.find('.js-address-lookup-response');
            $results.find('.address-finder-results-list').empty();

            if (data.Items.length === 1 && typeof (data.Items[0].Error) !== "undefined") {
                $errorWrapper.html('<div class="alert alert-danger">Unfortunately, we couldn&apos;t find your address. Please try again or enter your address manually below.</div>').slideDown();
                setTimeout(function () {
                    $errorWrapper.slideUp();
                }, 5000);
                $('.address-finder-results-list').slideUp();

                $results.slideDown();
            }
            else {
                $('.address-finder-results-list').slideDown();

                if (data.Items.length === 0) {
                    $errorWrapper.html('<div class="alert alert-danger">Unfortunately, we couldn&apos;t find your address. Please try again or enter your address manually below.</div>').slideDown();
                    setTimeout(function () {
                        $errorWrapper.slideUp();
                    }, 5000);

                    $('.address-finder-results-list').slideUp();
                    $results.slideDown();
                }
                else {
                    $.each(data.Items, function (key, value) {
                        $results.find('.address-finder-results-list').append('<a href="#" class="address-finder-result js-finder-address-details" data-id="' + value.Id + '">' + value.Text + ' ' + value.Description + '</a>');
                    });
                    $results.slideDown();
                }
            }
        });
}

function PostcodeAnywhere_Interactive_RetrieveById_v1_30($addressFinder, Key, Id, PreferredLanguage, UserName) {
    $.getJSON("https://api.addressy.com/Capture/Interactive/Retrieve/v1.30/json6.ws?callback=?",
        {
            Key: 'XD63-AJ85-CJ94-UW77',
            Id: Id
        },
        function (data) {
            $results = $addressFinder.find('.address-finder-results');
            $details = $addressFinder.find('.address-finder-details');
            $search = $addressFinder.find('.address-finder-search');
            if (data.Items.length === 1 && typeof (data.Items[0].Error) !== "undefined") {
                alert(data.Items[0].Description);
            }
            else {
                if (data.Items.length === 0)
                    alert("Sorry, there were no results");
                else {

                    var addressLine1 = (data.Items[0].Company ? data.Items[0].Company + ' ' : '') + data.Items[0].Line1;

                    $details.find('.address-finder-details-line-1').val(addressLine1);
                    $details.find('.address-finder-details-line-2').val(data.Items[0].Line2);
                    $details.find('.address-finder-details-city').val(data.Items[0].ProvinceName);
                    $details.find('.address-finder-details-postcode').val(data.Items[0].PostalCode);
                }
            }

            $search.slideUp();
            $results.slideUp();
            $details.slideDown();
        });
}

function BankAccountValidation_Interactive_Validate_v2_00($bankNameInput, AccountNumber, SortCode) {
    $.getJSON("https://api.addressy.com/BankAccountValidation/Interactive/Validate/v2.00/json6.ws?callback=?",
        {
            Key: 'XD63-AJ85-CJ94-UW77',
            AccountNumber: AccountNumber,
            SortCode: SortCode
        },
        function (data) {
            var item = (data.Items && data.Items.length > 0) ? data.Items[0] : null;

            // Check for missing payload, API errors, or invalid bank details
            var isInvalid = !item ||
                typeof item.Error !== "undefined" ||
                item.IsCorrect === false ||
                item.IsCorrect === "False";

            if (isInvalid) {
                // Show the error message
                $('.js-bank-lookup-response').html('<div class="alert alert-danger">Unfortunately we couldn&apos;t find your bank, please enter your bank name below manually</div>').slideDown();
                setTimeout(function () {
                    $('.js-bank-lookup-response').slideUp();
                }, 5000);
            }
            else {
                $bankNameInput.val(item.Bank + ' - ' + item.Branch);
            }
        });
}

function openFormSection($formSection) {
    $formSectionContent = $formSection.find('.form-section-content');
    $formSection.addClass('is-open');
    $formSectionContent.slideDown();
}

function closeFormSection($formSection) {
    $formSectionContent = $formSection.find('.form-section-content');
    $formSection.removeClass('is-open');
    $formSectionContent.slideUp();
}

function previewBarFixed() {
    $previewInner = $('.preview-inner');
    $previewDetails = $('.preview-details');

    var scrollPos = $(window).scrollTop(),
        previewSnapPoint = $('.preview-snap-point').offset().top - $('.header-nav-fixed.is-fixed').outerHeight(),
        marginTop = scrollPos - previewSnapPoint;

    if (!$previewDetails.hasClass('is-open') && scrollPos > previewSnapPoint && parseInt($previewInner.outerHeight() + marginTop) <= $('.preview').outerHeight()) {
        $('.preview-inner').css('margin-top', marginTop + 'px');
    }
    else if (scrollPos <= previewSnapPoint) {
        $('.preview-inner').css('margin-top', 0);
    }
}

function openPreviewDetails(scroll) {
    $link = $('.js-toggle-preview-details');
    $previewDetails = $('.preview-details');


    if ($previewDetails.hasClass('is-open')) {
        $previewDetails.removeClass('is-open');
        $previewDetails.slideUp(400, function () {
            $link.html('View All Vehicle Details <span class="preview-toggle-link-icon icon-chevron-down"></span>');
        });
    }
    else {
        if (scroll) {
            $("html, body").animate({
                scrollTop: $('.preview').offset().top - $('#main_nav').height()
            }, 400);
        }

        $('.preview-inner').css('margin-top', 0);
        $previewDetails.addClass('is-open');
        $previewDetails.slideDown(400, function () {
            $link.html('Hide Vehicle Details <span class="preview-toggle-link-icon icon-chevron-up"></span>');
        });
    }
}

function pushState(state) {

    var title = "Finance Application | Step " + state;
    var url = window.location.href.endsWith('/') ? window.location.href + "?step=" + state : window.location.href.replace("&step=" + (state - 1), '').replace("&step=" + (state + 1), '').replace("?step=" + (state - 1), '').replace("?step=" + (state + 1), '') + "?step=" + state;
    History.pushState({ state: state }, title, url);
}

function step(nextStep, backToStart, ignoreValidation) {
    getScreenSize();
    if (ignoreValidation && !backToStart) {
        currentStep--;
        pushState(currentStep);
        $('.form-section').each(function () {
            closeFormSection($(this));
        });
        var initialSection = $('.form-section.initial');
        initialSection.addClass('is-open');
        $('.form-section.initial').find('.form-section-content').slideDown(100);
        $('.form-step[data-step="' + (currentStep + 1) + '"]').hide();
        $('.form-step[data-step="' + currentStep + '"]').show();
        $('.header-nav-list-item[data-step="' + (currentStep + 1) + '"]').removeClass('is-active');
        $('.header-nav-list-item[data-step="' + currentStep + '"]').addClass('is-active');
        setTimeout(function () {
            $("html, body").animate({
                scrollTop: $('.header').first().offset().top - 20
            }, 100);
        }, 100);
    } else {
        $('.form-section').each(function () {
            openFormSection($(this));
        });
        if ($('#finance-form').valid()) {
            if (currentStep === 1) {
                $('input[name="StepOne.CompanyName"]').val($('#StepOne_CompanyName').val());
            } else if (currentStep === 2) {
                $('.firstName_label').text($('#StepOne_FirstName').val());
                $('.surname_label').text($('#StepOne_LastName').val());
                $('.email_label').text($('#StepOne_Email').val());
                $('.telephone_label').text($('#StepOne_ContactNumber').val());

                $('.companyName_label').text($('#StepOne_CompanyName').val());
                $('.companyType_label').text($('#StepOne_BusinessType').val());

                if ($.trim($('#StepTwo_CompanyVatRegistered:checked').siblings('small').text()) === '') {
                    $('.vatReg_label').text("No");
                } else {
                    $('.vatReg_label').text($('#StepTwo_CompanyVatRegistered:checked').siblings('small').text());
                }

                $('.dob_label').text($('#StepTwo_BirthDateDay').val() + "/" + $('#StepTwo_BirthDateMonth').val() + "/" + $('#StepTwo_BirthDateYear').val());
                $('.dependents_label').text($('#StepTwo_Dependants').val());
                $('.marital_label').text($('#StepTwo_MaritalStatus').val());

                $('.vatNumber_label').text($('#StepTwo_VatNumber').val());
                $('.businessNature_label').text($('#StepTwo_Comments').val());
                $('.established_label').text($('#StepTwo_DateDay').val() + "/" + $('#StepTwo_DateMonth').val() + "/" + $('#StepTwo_DateYear').val());
                $('.regNumber_label').text($('#StepTwo_CompanyRegNumber').val());
                $('.companyPhone_label').text($('#StepTwo_CompanyContactNumber').val());

                $('.companyAddressOne_label').text($('#StepTwo_AddressLineOne').val());
                $('.companyAddressTwo_label').text($('#StepTwo_AddressLineTwo').val());
                $('.companyCity_label').text($('#StepTwo_City').val());
                $('.companyPostcode_label').text($('#StepTwo_Postcode').val());

                if ($.trim($('#StepTwo_SameAsRegisteredAddress:checked').siblings('small').text()) === '') {
                    $('.sameAsRegistered_label').text("No");
                } else {
                    $('.sameAsRegistered_label').text($('#StepTwo_SameAsRegisteredAddress:checked').siblings('small').text());
                }

                if ($('#StepTwo_SameAsRegisteredAddress:checked').siblings('small').text() === "No") {
                    $('#registeredAddressContainer').show();
                    $('.registeredAddressOne_label').text($('#StepTwo_RegisteredAddressLineOne').val());
                    $('.registeredAddressTwo_label').text($('#StepTwo_RegisteredAddressLineTwo').val());
                    $('.registeredCity_label').text($('#StepTwo_RegisteredCity').val());
                    $('.registeredPostcode_label').text($('#StepTwo_RegisteredPostcode').val());
                }

                $('.bankAccName_label').text($('#StepTwo_AccountName').val());
                $('.bankNumber_label').text($('#StepTwo_AccountNumber').val());
                $('.bankCode_label').text($('#StepTwo_BankSortCode').val());
                $('.bankName_label').text($('#StepTwo_BankName').val());
                $('.bankYears_label').text($('#StepTwo_YearsWithBank').val());

                $('.annualIncome_label').text($('#StepTwo_AnnualIncome').val());
                $('.monthlySalary_label').text($('#StepTwo_MonthlySalary').val());
                $('.otherIncome_label').text($('#StepTwo_OtherIncome').val().length > 0 ? $('#StepTwo_OtherIncome').val() : "0");
                $('.mortgage_label').text($('#StepTwo_Mortgage').val().length > 0 ? $('#StepTwo_Mortgage').val() : "0");
                $('.utility_label').text($('#StepTwo_Utility').val().length > 0 ? $('#StepTwo_Utility').val() : "0");
                $('.creditCard_label').text($('#StepTwo_CreditCard').val().length > 0 ? $('#StepTwo_CreditCard').val() : "0");
                $('.existingCar_label').text($('#StepTwo_ExistingCar').val().length > 0 ? $('#StepTwo_ExistingCar').val() : "0");

                addAddressDetails();
                addDirectorDetails();
                addEmployeeDetails();

                if ($.trim($('#StepTwo_ReplaceExistingCarPayment:checked').siblings('small').text()) === '') {
                    $('.replacingCar_label').text("No");
                } else {
                    $('.replacingCar_label').text($('#StepTwo_ReplaceExistingCarPayment:checked').siblings('small').text());
                }

                $('.loans_label').text($('#StepTwo_Loans').val().length > 0 ? $('#StepTwo_Loans').val() : "0");
                $('.fooddrink_label').text($('#StepTwo_Food').val().length > 0 ? $('#StepTwo_Food').val() : "0");
                $('.childcare_label').text($('#StepTwo_ChildCare').val().length > 0 ? $('#StepTwo_ChildCare').val() : "0");
                $('.other_label').text($('#StepTwo_OtherOutgoings').val().length > 0 ? $('#StepTwo_OtherOutgoings').val() : "0");

                if ($.trim($('#StepTwo_RefusedCredit:checked').siblings('small').text()) === '') {
                    $('.creditRefused_label').text("No");
                } else {
                    $('.creditRefused_label').text($('#StepTwo_RefusedCredit:checked').siblings('small').text());
                }
            }
            $('input').closest('.form-group').removeClass('is-erroneous');
            $('input').closest('.form-section').removeClass('is-erroneous');

            $('[id=reg-errors]:visible').hide();
            if (nextStep) {
                if (currentStep == 1){
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event':'Dropout Trigger',
                        'DropoutTrigger':'true',
                        'submittedEmail':$('#StepOne_Email').val(),
                        'submittedFirstname':$('#StepOne_FirstName').val(),
                        'submittedSurname':$('#StepOne_LastName').val(),
                        'submittedPhone':$('#StepOne_ContactNumber').val()
                    });
                }
                var next = $('.next');
                next.attr("disabled", true);
                $.ajax({
                    type: "POST",
                    url: '/api/financeapi/financedata/?step=' + currentStep,
                    data: $("#finance-form").serialize(),
                    async: false,
                    success: function (data) {
                        if (data.userId) {
                            $('input[name="UserId"]').val(data.userId);
                        }
                        if (data.businessId) {
                            $('input[name="BusinessId"]').val(data.businessId);
                        }
                        if (data.orderId) {
                            $('input[name="OrderId"]').val(data.orderId);
                        }
                        currentStep++;
                        pushState(currentStep);
                        $('.form-section').each(function () {
                            closeFormSection($(this));
                        });
                        var initialSection = $('.form-section.initial');
                        initialSection.addClass('is-open');
                        $('.form-section.initial').find('.form-section-content').slideDown(100);
                        $('.form-step[data-step="' + currentStep + '"]').show();
                        $('.form-step[data-step="' + (currentStep - 1) + '"]').hide();
                        $('.header-nav-list-item[data-step="' + currentStep + '"]').addClass('is-active');
                        $('.header-nav-list-item[data-step="' + (currentStep - 1) + '"]').removeClass('is-active');
                        $('.js-page-loader').fadeOut();
                        setTimeout(function () {
                            next.removeAttr("disabled");
                        }, 3000);
                    },
                    error: function () {
                        //TODO: SHOW ERROR
                        next.removeAttr("disabled");
                        $('.js-page-loader').fadeOut();
                    }
                });
                setTimeout(function () {
                    $("html, body").animate({
                        scrollTop: $('.header').first().offset().top - 20
                    }, 100);
                }, 100);
            } else if (backToStart) {
                currentStep--;
                currentStep--;
                pushState(currentStep);
                $('.form-step[data-step="' + (currentStep + 2) + '"]').hide();
                $('.form-step[data-step="' + currentStep + '"]').show();
                $('.header-nav-list-item[data-step="' + (currentStep + 2) + '"]').removeClass('is-active');
                $('.header-nav-list-item[data-step="' + currentStep + '"]').addClass('is-active');
                setTimeout(function () {
                    $("html, body").animate({
                        scrollTop: $('.header').first().offset().top - 20
                    }, 100);
                }, 100);
            } else {
                currentStep--;
                pushState(currentStep);
                $('.form-step[data-step="' + (currentStep + 1) + '"]').hide();
                $('.form-step[data-step="' + currentStep + '"]').show();
                $('.header-nav-list-item[data-step="' + (currentStep + 1) + '"]').removeClass('is-active');
                $('.header-nav-list-item[data-step="' + currentStep + '"]').addClass('is-active');
                setTimeout(function () {
                    $("html, body").animate({
                        scrollTop: $('.header').first().offset().top - 20
                    }, 100);
                }, 100);
            }
        } else {
            $('.js-page-loader').fadeOut();
            if ($('#StepOne_AcceptTerms').closest('.is-checked').length === 0) {
                $('small[for=StepOne_AcceptTerms]').closest('.form-group').addClass('is-erroneous');
                $('small[for=StepOne_AcceptTerms]').closest('.form-section').addClass('is-erroneous');
            } else {
                $('small[for=StepOne_AcceptTerms]').closest('.form-group').removeClass('is-erroneous');
                $('small[for=StepOne_AcceptTerms]').closest('.form-section').removeClass('is-erroneous');
            }

            $('input.label-error').closest('.form-group').addClass('is-erroneous');
            $('input.label-error').closest('.form-section').addClass('is-erroneous');
            $('select.label-error').closest('.form-group').removeClass('is-erroneous').addClass('is-erroneous');
            $('select.label-error').closest('.form-section').removeClass('is-erroneous').addClass('is-erroneous');
            setTimeout(function () {
                $("html, body").animate({
                    scrollTop: $('.form-section.is-erroneous').first().offset().top - 20
                }, 600);
            }, 400);
            $('.js-page-loader').fadeOut();
        }
    }
}

function addAddressDetails() {
    var html = '';
    $('.address-details').each(function (index) {
        html += '<div class="col-xs-24 col-sm-12">' +
            '<h2 class="no-top-margin">Address ' + (index === 0 ? '' : (index + 1)) + '</h2>' +
            '<p class="clearfix"><strong>Address Line 1:</strong> <span>' + $(this).find('#OwnerAddressLineOne').val() + '</span></p>' +
            '<p class="clearfix"><strong>Address Line 2:</strong> <span>' + $(this).find('#OwnerAddressLineTwo').val() + '</span></p>' +
            '<p class="clearfix"><strong>City:</strong> <span>' + $(this).find('#OwnerCity').val() + '</span></p>' +
            '<p class="clearfix"><strong>Postcode:</strong> <span>' + $(this).find('#OwnerPostcode').val() + '</span></p>' +
            '<p class="clearfix"><strong>Time at Address Years:</strong> <span>' + $(this).find('#TimeAtAddressYears').val() + '</span></p>' +
            '<p class="clearfix"><strong>Time at Address Months:</strong> <span>' + $(this).find('#TimeAtAddressMonths').val() + '</span></p>' +
            '<p class="clearfix"><strong>Property Status:</strong> <span>' + $(this).find('#PropertyStatus').val() + '</span></p>' +
            '</div >';
    });
    $('#address-details').html(html);
}

function addEmployeeDetails() {
    var html = '';
    $('.employer-details').each(function (index) {
        html += '<div class="col-xs-24 col-sm-12">' +
            '<h2 class="no-top-margin">Employer ' + (index === 0 ? '' : (index + 1)) + '</h2>' +
            '<p class="clearfix"><strong>Status:</strong> <span>' + $(this).find('#EmploymentStatus').val() + '</span></p>' +
            '<p class="clearfix"><strong>Job Title:</strong> <span>' + $(this).find('#JobTitle').val() + '</span></p>' +
            '<p class="clearfix"><strong>Employer&apos;s Name:</strong> <span>' + $(this).find('#EmployersName').val() + '</span></p>' +
            '<p class="clearfix"><strong>Nature of Business:</strong> <span>' + $(this).find('#NatureOfBusiness').val() + '</span></p>' +
            '<p class="clearfix"><strong>Address Line 1:</strong> <span>' + $(this).find('#EmployersAddressLineOne').val() + '</span></p>' +
            '<p class="clearfix"><strong>Address Line 2:</strong> <span>' + $(this).find('#EmployersAddressLineTwo').val() + '</span></p>' +
            '<p class="clearfix"><strong>City:</strong> <span>' + $(this).find('#EmployersCity').val() + '</span></p>' +
            '<p class="clearfix"><strong>Postcode:</strong> <span>' + $(this).find('#EmployersPostcode').val() + '</span></p>' +
            '<p class="clearfix"><strong>Time With Employer:</strong> <span>' + $(this).find('#EmploymentYears').val() + ' Years ' + $(this).find('#EmploymentMonths').val() + ' Months</span></p>' +
            '</div>';
    });
    $('#employer-details').html(html);
}

function addDirectorDetails() {
    var html = '';
    $('.director-details').each(function () {
        html += '<div class="col-xs-24">' +
            '<div class="form-section">' +
            '<h2 class="form-section-heading">' +
            '<a href="#" class="form-section-link js-toggle-form-section">Company Director / Partner / Owner Details <span class="form-section-link-icon icon-chevron-down"></span></a>' +
            '</h2>' +
            '<div class="form-section-content">' +
            '<p class="clearfix"><strong>Title:</strong> <span>' + $(this).find('#form_owner_title').val() + '</span></p>' +
            '<p class="clearfix"><strong>First Name:</strong> <span>' + $(this).find('#form_first_name').val() + '</span></p>' +
            '<p class="clearfix"><strong>Surname:</strong> <span>' + $(this).find('#form_surname').val() + '</span></p>' +
            '<p class="clearfix"><strong>Email Address:</strong> <span>' + $(this).find('#form_email_address').val() + '</span></p>' +
            '<p class="clearfix"><strong>Telephone:</strong> <span>' + $(this).find('#form_telephone').val() + '</span></p>' +
            '<p class="clearfix"><strong>Date of Birth:</strong> <span>' + $(this).find('#form_dob_day').val() + '/' + $(this).find('#form_dob_month').val() + '/' + $(this).find('#form_dob_year').val() + '</span></p>' +
            '<p class="clearfix"><strong>Dependents:</strong> <span>' + $(this).find('#form_dependants').val() + '</span></p>' +
            '<p class="clearfix"><strong>Marital Status:</strong> <span>' + $(this).find('#form_marital_status').val() + '</span></p>' +
            '<div class="row">';
        $(this).find('.address-details').each(function (index) {
            html += '<div class="col-xs-24 col-sm-12">' +
                '<h2 class="no-top-margin">Address ' + (index === 0 ? '' : (index + 1)) + '</h2>' +
                '<p class="clearfix"><strong>Address Line 1:</strong> <span>' + $(this).find('#OwnerAddressLineOne').val() + '</span></p>' +
                '<p class="clearfix"><strong>Address Line 2:</strong> <span>' + $(this).find('#OwnerAddressLineTwo').val() + '</span></p>' +
                '<p class="clearfix"><strong>City:</strong> <span>' + $(this).find('#OwnerCity').val() + '</span></p>' +
                '<p class="clearfix"><strong>Postcode:</strong> <span>' + $(this).find('#OwnerPostcode').val() + '</span></p>' +
                '<p class="clearfix"><strong>Time at Address Years:</strong> <span>' + $(this).find('#TimeAtAddressYears').val() + '</span></p>' +
                '<p class="clearfix"><strong>Time at Address Months:</strong> <span>' + $(this).find('#TimeAtAddressMonths').val() + '</span></p>' +
                '<p class="clearfix"><strong>Property Status:</strong> <span>' + $(this).find('#PropertyStatus').val() + '</span></p>' +
                '</div>';
        });
        html += '</div>' +
            '<p><a class="btn blue-btn btn-sm back-link-prev">Edit Details</a></p>' +
            '</div></div></div>';
    });
    $('#company-director-details').html(html);
}

$(function () {
    $.validator.addMethod("regex", function (value, element) { return value === "" || RegExp(element.dataset.ruleRegex).test(value); }, "Invalid value");
    $.validator.addMethod("postcode", function (value, element) { return value === "" || RegExp("^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9]){1}([        ])([0-9][a-zA-z][a-zA-z]){1}$").test(value); }, "Invalid post code");
    $.validator.addMethod("minduration", function (value, element) {
        var parent = element.closest(".form-group");

        if (!parent) {
            return true;
        }
        var rawMonth = parent.querySelector("[data-type=months]").value;
        var rawYear = parent.querySelector("[data-type=years]").value;
        if (rawMonth === "" || rawYear === "") {
            return false;
        }
        if (rawMonth === "0" && rawYear === "0") {
            return false;
        }
        return true;
    }, "");
    $.validator.addMethod("datesegments",
        function (value, element) {
            var parent = element.closest(".form-group");

            if (!parent) {
                return true;
            }

            var rawDay = parent.querySelector("[data-type=day]").value;
            var rawMonth = parent.querySelector("[data-type=month]").value;
            var rawYear = parent.querySelector("[data-type=year]").value;

            if (rawDay === "" || rawMonth === "" || rawYear === "") {
                return true;
            }

            var day = parseInt(rawDay) || 0;
            var month = (parseInt(rawMonth) || 1) - 1;
            var year = parseInt(rawYear) || 0;

            if (day < 1 || day > 31 || month < 0 || month > 11 || year < 1) {
                return false;
            }

            return new Date(year, month, day).getMonth() === month;
        },
        "Invalid date");

    getScreenSize();
    $(document).on('click', '.pt-cookie-link',
        function (e) {
            cookies.set("pt", $(this).data("pt"), 30);
        });

    if ($('.js-toggle-directors').val() !== undefined && $('.js-toggle-directors').val().length > 0) {
        var value = $('.js-toggle-directors').val();
        if (value === 'Sole Trader' || value === 'Partnership <4') {
            $('.income-section').removeClass('hidden');
            $('#income-summary').removeClass('hidden');
        }
        else {
            $('.income-section').addClass('hidden');
            $('#income-summary').addClass('hidden');
        }
    }

    $(document).on('click', '#finance-form button.next', function (e) {
        e.preventDefault();
        $('.js-page-loader').fadeIn(100, function () {
            step(true, false, false);
        });
    });

    $(document).on('click', '#finance-form a.back-link:not([href])', function (e) {
        e.preventDefault();
        step(false, false, true);
    });

    $(document).on('click', '#finance-form a.back-link-prev', function (e) {
        e.preventDefault();
        step(false, false, true);
    });

    $(document).on('click', '#finance-form a.back-link-start', function (e) {
        e.preventDefault();
        step(false, true, true);
    });

    $(document).on('click', '#finance-form a.submit', function () {
        var form = $("#finance-form");
        var submit = form.find('a.submit');
        var currentText = "Submit My Application";

        if (submit.length) {
            submit.text("Submitting...");
        } else {
            submit = form.find("input[type='submit']");
            submit.val("Submitting...");
        }
        $('.blue-btn').attr('disabled', true);
        submit.attr("disabled", true);
        $('.js-page-loader').fadeIn();
        $.ajax(
            {
                url: form.attr('action'),
                data: form.serialize(),
                type: "POST",
                success: function (response) {
                    pushState(4);
                    $('#finance-form-container').html(response);
                    $('.previous-url-back').hide();
                    $('.js-page-loader').fadeOut();

                    window.addEventListener('popstate', function (event) {
                        window.location.href = '/';
                    });
                },
                error: function () {
                    $('.blue-btn').removeAttr('disabled', true);
                    submit.removeAttr("disabled");
                    submit.text(currentText);
                }
            });
    });

    $(document).on('click', '.js-toggle-form-section .tooltip', function (e) {
        e.stopPropagation();
        e.preventDefault();
    });

    $(document).on('click', '.js-toggle-preview-details', function (e) {
        e.preventDefault();
        openPreviewDetails(true);
    });

    $(document).on('change keyup', '.js-credit-card-payments', function (e) {
        $('.credit-cards-yes').prop('checked', true);
        $('.credit-cards-no').prop('checked', false);
        $('.credit-cards-yes').trigger('change');
    });

    $(document).on('change', '.form-control.js-toggle-directors', function () {
        $('.form-control.js-toggle-directors').val($(this).val());
    });
    
    $(document).on('change', '.js-toggle-directors', function (e) {
        var value = $(this).val();

        setDirectorFields(value)
    });

    $(document).on('change', '.js-toggle-directors-by-num', function (e) {
        var value = $(this).val();
        var company = $('#StepOne_BusinessType').val();
        if (company === 'Sole Trader') {
            addNewDirectors(value, false);
        }
        else if (company === 'Partnership 4+' || company === 'LLP' || company === 'Limited Company' || company === 'PLC' || company === 'Partnership <4') {
            addNewDirectors(value, false);
        }
    });

    var clickEventType = ((document.ontouchstart !== null) ? 'click' : 'touchstart');

    $(document).on(clickEventType, '.js-summary-toggle', function (e) {
        e.preventDefault();
        $('body').toggleClass('preview-open');
    });

    $(document).on(clickEventType, '.js-close-summary', function (e) {
        e.preventDefault();
        $('body').removeClass('preview-open');
    });

    $(document).on('click', '.js-toggle-form-section', function (e) {
        e.preventDefault();

        $formSection = $(this).parents('.form-section');

        if ($formSection.hasClass('is-open')) {
            closeFormSection($formSection);
        }
        else {
            openFormSection($formSection);
        }
    });

    $(document).on('click', '.js-toggle-form-section .tooltip', function (e) {
        e.stopPropagation();
        e.preventDefault();
    });

    $(document).on('click', '.js-toggle-preview-details', function (e) {
        e.preventDefault();
        openPreviewDetails(true);
    });

    if ($('.header-nav-wrapper').length > 0) {
        $(window).on('scroll', function () {

            var scrollPos = $(window).scrollTop(),
                navSnapPoint = $('.header-nav-wrapper').offset().top,
                $nav = $('.header-nav-fixed');

            if (scrollPos >= navSnapPoint) {
                $nav.addClass('is-fixed');
            }
            else {
                $nav.removeClass('is-fixed');
            }
        });
    }

    if ($('.preview-inner').length > 0) {
        $(window).on('scroll', function () {
            previewBarFixed();
        });
    }

    $(document).on('change keyup', '.js-toggle-existing-finance-field', function (e) {
        if ($(this).val() > 0) {
            $('.existing-finance-field').slideDown();
        }
        else {
            $('.existing-finance-field').slideUp();
        }
    });

    $(document).on('change', '.checkbox-styled input[type="checkbox"]', function (e) {
        if ($(this).is(':checked')) {
            $(this).parents('.checkbox-styled').addClass('is-checked');
        }
        else {
            $(this).parents('.checkbox-styled').removeClass('is-checked');
        }
    });

    $(document).on('change', '.radio-styled input[type="radio"]', function (e) {

        $radios = $(this).parents('.radio-styled-wrapper').find('.radio-styled');
        $radios.removeClass('is-checked');
        $(this).parents('.radio-styled').addClass('is-checked');

    });

    $(document).on('change', '.js-on-togge-show-more-than-one-vehicle-text', function (e) {
        if ($(this).val() === 1) {
            $('.js-more-than-one-vehicle-text').slideDown();
        }
        else {
            $('.js-more-than-one-vehicle-text').slideUp();
        }
    });

    $(document).on('click', '.js-find-address', function (e) {
        e.preventDefault();

        $addressFinder = $(this).parents('.address-finder');
        var postcode = $addressFinder.find('.address-finder-postcode').val();

        PostcodeAnywhere_Interactive_Find_v1_10($addressFinder, window.pcaKey, postcode);
    });

    $(document).on('click', '.js-finder-address-details', function (e) {
        e.preventDefault();

        $addressFinder = $(this).parents('.address-finder');

        PostcodeAnywhere_Interactive_RetrieveById_v1_30($addressFinder, window.pcaKey, $(this).data('id'));

    });

    $(document).on('click', '.js-show-address-details', function (e) {
        e.preventDefault();
        $addressFinder = $(this).parents('.address-finder');
        $results = $addressFinder.find('.address-finder-results');
        $details = $addressFinder.find('.address-finder-details');
        $search = $addressFinder.find('.address-finder-search');

        $search.slideUp();
        $results.slideUp();
        $details.slideDown();
    });

    $(document).on('click', '.js-find-bank-details', function (e) {
        e.preventDefault();

        var accountNumber = $('#StepTwo_AccountNumber').val(),
            sortCode = $('#StepTwo_BankSortCode').val();

        BankAccountValidation_Interactive_Validate_v2_00($('#StepTwo_BankName'), accountNumber, sortCode);

    });

    function cloneOwnerAddress($el) {
        var initialInstanceNum = $el.closest('.form-section.director-details').data('number');
        var addressHtml = generateOwnerAddressHtml($el, false, initialInstanceNum);
        $el.append(addressHtml);
    }

    function cloneAddress($el) {
        var addressHtml = generateAddressHtml($el, false);
        $el.append(addressHtml);
    }

    function generateOwnerAddressHtml($wrapper, removeValidation, intitialInstanceNum) {

        var instanceNum = parseInt($wrapper.find('.address-details').length);
        var namePrefix = "StepTwo.Owners[" + intitialInstanceNum + "].OwnerAddress";
        var idPrefix = "StepTwo_Owners_" + intitialInstanceNum + "_OwnerAddress";

        var html = '<div class="address-details">' +
            (instanceNum !== 0 ? '<h3>Address ' + (instanceNum + 1) + '</h3>' : '') +
            '<div class="address-finder">' +
            '<div class="row">' +
            '<div class="col-xs-24">' +
            '<div class="address-lookup-response js-address-lookup-response"></div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="address-finder-search">' +
            '<div class="row">' +
            '<div class="col-xs-24 col-sm-16">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_postcode_' + instanceNum + '">Postcode' + (removeValidation === true ? '' : '*') + '</label>  <small class="label-error" for="form_postcode_' + instanceNum + '"></small>' +
            '<input type="text" name="' + namePrefix + '[' + instanceNum + '].Postcode" id="form_postcode_' + instanceNum + '" class="form-control address-finder-postcode" autocomplete="off" ' + (removeValidation === true ? '' : 'required data-msg-required = "A postcode is required" data-rule-postcode=""') + '>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-8">' +
            '<div class="form-group">' +
            '<label class="response-label" class="hidden-xs">&nbsp;</label>' +
            '<div>' +
            '<a href="#" class="btn btn-primary btn-block mod-form-height js-find-address">Find my address <span class="icon icon-magnifying-glass"></span></a>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="address-finder-results" style="display: none;"><div class="address-finder-results-list"></div><a href="#" class="address-finder-manually js-show-address-details">Enter Manually</a></div>' +
            '<div class="address-finder-details">' +
            '<div class="row">' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerAddress_' + instanceNum + '_OwnerAddressLineOne">Address Line 1' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="OwnerAddressLineOne"></small>' +
            '<input type="text" name="' + namePrefix + '[' + instanceNum + '].OwnerAddressLineOne" id="OwnerAddressLineOne" maxlength="50" class="form-control address-finder-details-line-1 js-validate-check" autocomplete="off" ' + (removeValidation === true ? '' : 'required data-msg-required = "An address is required"') + '>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerAddress_' + instanceNum + '_OwnerAddressLineTwo">Address Line 2</label>' +
            '<input type="text" name="' + namePrefix + '[' + instanceNum + '].OwnerAddressLineTwo" id="OwnerAddressLineTwo" maxlength="50" autocomplete="off" class="form-control address-finder-details-line-2 js-validate-check">' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerAddress_' + instanceNum + '_OwnerCity">City/Town' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="OwnerCity"></small>' +
            '<input type="text" name="' + namePrefix + '[' + instanceNum + '].OwnerCity" id="OwnerCity" maxlength="50" autocomplete="off" class="form-control address-finder-details-city js-validate-check" ' + (removeValidation === true ? '' : 'required data-msg-required = "A city or town is required"') + '>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerAddress_' + instanceNum + '_OwnerPostcode">Postcode' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="OwnerPostcode"></small>' +
            '<input type="text" name="' + namePrefix + '[' + instanceNum + '].OwnerPostcode" id="OwnerPostcode" class="form-control address-finder-details-postcode js-validate-check" maxlength = "8" autocomplete="off" ' + (removeValidation === true ? '' : 'required data-msg-required = "A postcode is required"') + ' data-rule-postcode="">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="row">' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerAddress_' + instanceNum + '_TimeAtAddressYears">Time at Address' + (removeValidation === true ? '' : '*') + '</label>' +
            (removeValidation === true ? '' : ' <small class="label-error" for="TimeAtAddressYears"></small>') +
            (removeValidation === true ? '' : ' <small class="label-error" for="TimeAtAddressMonths"></small>') +
            '<div class="row">' +
            '<div class="col-xs-12">' +
            '<select name="' + namePrefix + '[' + instanceNum + '].TimeAtAddressYears" id="TimeAtAddressYears" class="form-control js-on-change-address-clone" data-type="years"' + (removeValidation === true ? '' : ' data-msg-required="Years at address is required" required data-rule-minduration=""') + '>' +
            '<option value="">Years</option>' +
            '<option value="0">0 Years</option>' +
            '<option value="1">1 Year</option>' +
            '<option value="2">2 Years</option>' +
            '<option value="3">3 Years</option>' +
            '<option value="4">4 Years</option>' +
            '<option value="5">5 Years</option>' +
            '<option value="6">6 Years</option>' +
            '<option value="7">7 Years</option>' +
            '<option value="8">8 Years</option>' +
            '<option value="9">9 Years</option>' +
            '<option value="10">10 Years</option>' +
            '<option value="11">11 Years</option>' +
            '<option value="12">12 Years</option>' +
            '<option value="13">13 Years</option>' +
            '<option value="14">14 Years</option>' +
            '<option value="15">15 Years</option>' +
            '<option value="16">16 Years</option>' +
            '<option value="17">17 Years</option>' +
            '<option value="18">18 Years</option>' +
            '<option value="19">19 Years</option>' +
            '<option value="20">20 Years</option>' +
            '<option value="21">21 Years</option>' +
            '<option value="22">22 Years</option>' +
            '<option value="23">23 Years</option>' +
            '<option value="24">24 Years</option>' +
            '<option value="25">25 Years</option>' +
            '<option value="26">26 Years</option>' +
            '<option value="27">27 Years</option>' +
            '<option value="28">28 Years</option>' +
            '<option value="29">29 Years</option>' +
            '<option value="30">30 Years</option>' +
            '<option value="31">31 Years</option>' +
            '<option value="32">32 Years</option>' +
            '<option value="33">33 Years</option>' +
            '<option value="34">34 Years</option>' +
            '<option value="35">35 Years</option>' +
            '<option value="36">36 Years</option>' +
            '<option value="37">37 Years</option>' +
            '<option value="38">38 Years</option>' +
            '<option value="39">39 Years</option>' +
            '<option value="40">40 Years</option>' +
            '<option value="41">41 Years</option>' +
            '<option value="42">42 Years</option>' +
            '<option value="43">43 Years</option>' +
            '<option value="44">44 Years</option>' +
            '<option value="45">45 Years</option>' +
            '<option value="46">46 Years</option>' +
            '<option value="47">47 Years</option>' +
            '<option value="48">48 Years</option>' +
            '<option value="49">49 Years</option>' +
            '<option value="50">50 Years</option>' +
            '<option value="51">More than 50 Years</option>' +
            '</select>' +
            '</div>' +
            '<div class="col-xs-12">' +
            '<select name="' + namePrefix + '[' + instanceNum + '].TimeAtAddressMonths" id="TimeAtAddressMonths" class="form-control js-on-change-address-clone" data-type="months"' + (removeValidation === true ? '' : ' data-msg-required="Months at address is required" required data-rule-minduration=""') + '>' +
            '<option value="">Months</option>' +
            '<option value="0">0 Months</option>' +
            '<option value="1 ">1 Month</option>' +
            '<option value="2">2 Months</option>' +
            '<option value="3">3 Months</option>' +
            '<option value="4">4 Months</option>' +
            '<option value="5">5 Months</option>' +
            '<option value="6">6 Months</option>' +
            '<option value="7">7 Months</option>' +
            '<option value="8">8 Months</option>' +
            '<option value="9">9 Months</option>' +
            '<option value="10">10 Months</option>' +
            '<option value="11">11 Months</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="PropertyStatus">Property Status' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="PropertyStatus"></small>' +
            '<select name="' + namePrefix + '[' + instanceNum + '].PropertyStatus" id="PropertyStatus"  class="form-control"' + (removeValidation === true ? '' : ' required="required"') + '>' +
            '<option value="">Please choose</option>' +
            '<option value="Outright Owner">Outright Owner</option>' +
            '<option value="Mortgaged Owner">Mortgaged Owner</option>' +
            '<option value="Renting">Renting</option>' +
            '<option value="Living with Parents">Living with Parents</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        return html;
    }

    function generateAddressHtml($wrapper, removeValidation) {

        var instanceNum = parseInt($wrapper.find('.address-details').length);

        var namePrefix = "StepTwo.OwnerAddress[" + instanceNum + "]";
        var idPrefix = "StepTwo_OwnerAddress_" + instanceNum;

        var html = '<div class="address-details">' +
            (instanceNum !== 0 ? '<h3>Address ' + (instanceNum + 1) + '</h3>' : '') +
            '<div class="address-finder">' +
            '<div class="row">' +
            '<div class="col-xs-24">' +
            '<div class="address-lookup-response js-address-lookup-response"></div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="address-finder-search">' +
            '<div class="row">' +
            '<div class="col-xs-24 col-sm-16">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_postcode_' + instanceNum + '">Postcode*</label> <small class="label-error" for="form_postcode_' + instanceNum + '"></small>' +
            '<input type="text" name="' + namePrefix + '.Postcode" id="form_postcode_' + instanceNum + '" class="form-control address-finder-postcode" required autocomplete="off" data-msg-required = "A postcode is required" data-rule-postcode="">' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-8">' +
            '<div class="form-group">' +
            '<label class="response-label" class="hidden-xs">&nbsp;</label>' +
            '<div>' +
            '<a href="#" class="btn btn-primary btn-block mod-form-height js-find-address">Find my address <span class="icon icon-magnifying-glass"></span></a>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="address-finder-results" style="display: none;"><div class="address-finder-results-list"></div><a href="#" class="address-finder-manually js-show-address-details">Enter Manually</a></div>' +
            '<div class="address-finder-details">' +
            '<div class="row">' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerAddressLineOne">Address Line 1*</label> <small class="label-error" for="OwnerAddressLineOne"></small>' +
            '<input type="text" name="' + namePrefix + '.OwnerAddressLineOne" id="OwnerAddressLineOne" maxlength="50" class="form-control address-finder-details-line-1 js-validate-check" autocomplete="off" required data-msg-required = "An address is required"> ' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerAddressLineTwo">Address Line 2</label>' +
            '<input type="text" name="' + namePrefix + '.OwnerAddressLineTwo" id="OwnerAddressLineTwo" autocomplete="off" maxlength="50" class="form-control address-finder-details-line-2 js-validate-check">' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerCity">City/Town*</label> <small class="label-error" for="OwnerCity"></small>' +
            '<input type="text" name="' + namePrefix + '.OwnerCity" id="OwnerCity" autocomplete="off" maxlength="50" class="form-control address-finder-details-city js-validate-check" required data-msg-required="A city or town is required">' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_OwnerPostcode">Postcode*</label> <small class="label-error" for="OwnerPostcode"></small>' +
            '<input type="text" name="' + namePrefix + '.OwnerPostcode" id="OwnerPostcode" class="form-control address-finder-details-postcode js-validate-check" maxlength = "8" autocomplete="off" data-msg-required = "A postcode is required" required data-rule-postcode="">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="row">' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="' + idPrefix + '_TimeAtAddressYears">Time at Address' + (removeValidation === true ? '' : '*') + '</label>' +
            (removeValidation === true ? '' : ' <small class="label-error" for="TimeAtAddressYears"></small>') +
            (removeValidation === true ? '' : ' <small class="label-error" for="TimeAtAddressMonths"></small>') +
            '<div class="row">' +
            '<div class="col-xs-12">' +
            '<select name="' + namePrefix + '.TimeAtAddressYears" id="TimeAtAddressYears" class="form-control js-on-change-address-clone" data-type="years"' + (removeValidation === true ? '' : ' data-msg-required="Years at address is required" required data-rule-minduration=""') + '>' +
            '<option value="">Years</option>' +
            '<option value="0">0 Years</option>' +
            '<option value="1">1 Year</option>' +
            '<option value="2">2 Years</option>' +
            '<option value="3">3 Years</option>' +
            '<option value="4">4 Years</option>' +
            '<option value="5">5 Years</option>' +
            '<option value="6">6 Years</option>' +
            '<option value="7">7 Years</option>' +
            '<option value="8">8 Years</option>' +
            '<option value="9">9 Years</option>' +
            '<option value="10">10 Years</option>' +
            '<option value="11">11 Years</option>' +
            '<option value="12">12 Years</option>' +
            '<option value="13">13 Years</option>' +
            '<option value="14">14 Years</option>' +
            '<option value="15">15 Years</option>' +
            '<option value="16">16 Years</option>' +
            '<option value="17">17 Years</option>' +
            '<option value="18">18 Years</option>' +
            '<option value="19">19 Years</option>' +
            '<option value="20">20 Years</option>' +
            '<option value="21">21 Years</option>' +
            '<option value="22">22 Years</option>' +
            '<option value="23">23 Years</option>' +
            '<option value="24">24 Years</option>' +
            '<option value="25">25 Years</option>' +
            '<option value="26">26 Years</option>' +
            '<option value="27">27 Years</option>' +
            '<option value="28">28 Years</option>' +
            '<option value="29">29 Years</option>' +
            '<option value="30">30 Years</option>' +
            '<option value="31">31 Years</option>' +
            '<option value="32">32 Years</option>' +
            '<option value="33">33 Years</option>' +
            '<option value="34">34 Years</option>' +
            '<option value="35">35 Years</option>' +
            '<option value="36">36 Years</option>' +
            '<option value="37">37 Years</option>' +
            '<option value="38">38 Years</option>' +
            '<option value="39">39 Years</option>' +
            '<option value="40">40 Years</option>' +
            '<option value="41">41 Years</option>' +
            '<option value="42">42 Years</option>' +
            '<option value="43">43 Years</option>' +
            '<option value="44">44 Years</option>' +
            '<option value="45">45 Years</option>' +
            '<option value="46">46 Years</option>' +
            '<option value="47">47 Years</option>' +
            '<option value="48">48 Years</option>' +
            '<option value="49">49 Years</option>' +
            '<option value="50">50 Years</option>' +
            '<option value="51">More than 50 Years</option>' +
            '</select>' +
            '</div>' +
            '<div class="col-xs-12">' +
            '<select name="' + namePrefix + '.TimeAtAddressMonths" id="TimeAtAddressMonths" class="form-control js-on-change-address-clone" data-type="months"' + (removeValidation === true ? '' : ' data-msg-required="Months at address is required" required data-rule-minduration=""') + '>' +
            '<option value="">Months</option>' +
            '<option value="0">0 Months</option>' +
            '<option value="1 ">1 Month</option>' +
            '<option value="2">2 Months</option>' +
            '<option value="3">3 Months</option>' +
            '<option value="4">4 Months</option>' +
            '<option value="5">5 Months</option>' +
            '<option value="6">6 Months</option>' +
            '<option value="7">7 Months</option>' +
            '<option value="8">8 Months</option>' +
            '<option value="9">9 Months</option>' +
            '<option value="10">10 Months</option>' +
            '<option value="11">11 Months</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="PropertyStatus">Property Status' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="PropertyStatus"></small>' +
            '<select name="' + namePrefix + '.PropertyStatus" id="PropertyStatus"  class="form-control"' + (removeValidation === true ? '' : ' required="required"') + '>' +
            '<option value="">Please choose</option>' +
            '<option value="Outright Owner">Outright Owner</option>' +
            '<option value="Mortgaged Owner">Mortgaged Owner</option>' +
            '<option value="Renting">Renting</option>' +
            '<option value="Living with Parents">Living with Parents</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        return html;
    }

    if ($('.address-details').length === 0) {
        $('.js-address-details').each(function () {
            cloneOwnerAddress($(this));
        });
    }

    $(document).on('change', '.js-on-change-address-clone', function (e) {
        e.preventDefault();
        var months = 0;
        var requiredMonths = 60;
        var cloneRequired = true;
        var wrapper = $(this).parents('.js-address-details');

        wrapper.find('.js-on-change-address-clone').each(function () {
            if (months < requiredMonths) {
                var value = Number($(this).val());

                if ($(this).val() === '') {
                    cloneRequired = false;
                }

                if ($(this).data('type') === 'years') {
                    var thisMonths = parseInt(value * 12);
                    months = parseInt(months + thisMonths);
                }
                else {
                    months = parseInt(months + value);
                }

                if (months >= requiredMonths) {
                    cloneRequired = false;
                }
                else {
                    cloneRequired = true;
                }
            }
            else {
                cloneRequired = false;
                if ($(this).data('type') === 'years') {
                    $(this).parents('.address-details').remove();
                }
            }
        });

        var last = $(this).closest('.js-address-details').find('.address-details:visible').last();

        if (cloneRequired === true && last.find('#TimeAtAddressYears').val() !== "" && last.find('#TimeAtAddressMonths').val() !== "") {
            var pricingType = $('#finance_application_step_1').data('pricingtype');

            if (pricingType === "Business")
                cloneOwnerAddress(wrapper);
            else
                cloneAddress(wrapper);
        }
    });

    function cloneEmployer() {
        var instanceNum = parseInt($('.employer-details').length);

        var html = '<div class="employer-details">' +
            (instanceNum !== 0 ? '<h3>Employer ' + (instanceNum + 1) + '</h3>' : '') +
            '<div class="row">' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_employment_status_' + instanceNum + '">Employment Status*</label>' +
            '<select name="StepTwo.Employers[' + instanceNum + '].EmploymentStatus" id="EmploymentStatus" class="form-control js-toggle-job-details">' +
            '<option value=""></option>' +
            '<option value="Permanent (Full Time)">Full Time</option>' +
            '<option value="Permanent (Part Time)">Part Time</option>' +
            '<option value="Temporary (Full Time)">Temporary</option>' +
            '<option value="Self Employed">Self Employed</option>' +
            '<option value="Retired">Retired</option>' +
            '<option value="Student">Student</option>' +
            '<option value="Unemployed">Unemployed</option>' +
            '<option value="Home Maker">Home Maker</option>' +
            '</select>' +
            '</div>         ' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_time_with_employer_years_' + instanceNum + '">Duration*</label>' +
            ' <small class="label-error" for="EmploymentYears"></small>' +
            ' <small class="label-error" for="EmploymentMonths"></small>' +
            '<div class="row">' +
            '<div class="col-xs-12">' +
            '<select name="StepTwo.Employers[' + instanceNum + '].EmploymentYears" id="EmploymentYears" class="form-control js-on-change-employer-clone" data-type="years" data-msg-required="Years of employment is required" required>' +
            '<option value="">Years</option>' +
            '<option value="0">0 Years</option>' +
            '<option value="1">1 Year</option>' +
            '<option value="2">2 Years</option>' +
            '<option value="3">3 Years</option>' +
            '<option value="4">4 Years</option>' +
            '<option value="5">5 Years</option>' +
            '<option value="6">6 Years</option>' +
            '<option value="7">7 Years</option>' +
            '<option value="8">8 Years</option>' +
            '<option value="9">9 Years</option>' +
            '<option value="10">10 Years</option>' +
            '<option value="11">More than 10 Years</option>' +
            '</select>' +
            '</div>' +
            '<div class="col-xs-12">' +
            '<select name="StepTwo.Employers[' + instanceNum + '].EmploymentMonths" id="EmploymentMonths" class="form-control js-on-change-employer-clone" data-type="months" data-msg-required="Months of employment is required" required>' +
            '<option value="">Months</option>' +
            '<option value="0">0 Months</option>' +
            '<option value="1">1 Month</option>' +
            '<option value="2">2 Months</option>' +
            '<option value="3">3 Months</option>' +
            '<option value="4">4 Months</option>' +
            '<option value="5">5 Months</option>' +
            '<option value="6">6 Months</option>' +
            '<option value="7">7 Months</option>' +
            '<option value="8">8 Months</option>' +
            '<option value="9">9 Months</option>' +
            '<option value="10">10 Months</option>' +
            '<option value="11">11 Months</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="employer-job-details" style="display: none;">' +
            '<div class="row">' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_job_title_' + instanceNum + '">Job Title*</label> <small class="label-error" for="JobTitle"></small>' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '].JobTitle" id="JobTitle" class="form-control js-validate-check" maxlength="100" autocomplete = "off" required data-msg-required = "A job title is required">' +
            '</div>         ' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_employer_name_' + instanceNum + '">Employer&apos;s name*</label> <small class="label-error" for="EmployersName"></small>' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '].EmployersName" id="EmployersName" class="form-control js-validate-check" maxlength="100" autocomplete = "off" required data-msg-required = "An employers name is required">' +
            '</div>         ' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_nature_of_business_' + instanceNum + '">Nature of Business*</label> <small class="label-error" for="NatureOfBusiness"></small>' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '].NatureOfBusiness" id="NatureOfBusiness" class="form-control js-validate-check" autocomplete = "off" required data-msg-required = "A nature of the business is required" >' +
            '</div>         ' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="address-finder">' +
            '<div class="address-finder-search">' +
            '<div class="row">' +
            '<div class="col-xs-24 col-sm-16">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_employers_postcode_' + instanceNum + '">Employer\'s Postcode*</label> <small class="label-error" for="StepTwo_Employers_' + instanceNum + '_postcode"></small>' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '][postcode]" id="StepTwo_Employers_' + instanceNum + '_postcode" class="form-control address-finder-postcode js-validate-check" autocomplete = "off" required data-msg-required = "An employer\'s postcode is required" data-rule-postcode="">' +
            '</div>         ' +
            '</div>' +
            '<div class="col-xs-24 col-sm-8">' +
            '<div class="form-group">' +
            '<label class="response-label" class="hidden-xs">&nbsp;</label>' +
            '<div>' +
            '<a href="#" class="btn btn-primary btn-block mod-form-height js-find-address">Find address <span class="icon icon-magnifying-glass"></span></a>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="address-finder-results" style="display: none;"><div class="address-finder-results-list"></div><a href="#" class="address-finder-manually js-show-address-details">Enter Manually</a></div>' +
            '<div class="address-finder-details">' +
            '<div class="row">' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_employers_line_1_' + instanceNum + '">Address Line 1*</label> <small class="label-error" for="EmployersAddressLineOne"></small>' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '].EmployersAddressLineOne" id="EmployersAddressLineOne" maxlength="50" class="form-control address-finder-details-line-1 js-validate-check" autocomplete = "off" required data-msg-required = "An address is required">' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_employers_line_2_' + instanceNum + '">Address Line 2</label> ' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '].EmployersAddressLineTwo" id="EmployersAddressLineTwo" autocomplete = "off" maxlength="50" class="form-control address-finder-details-line-2">' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_employers_city_' + instanceNum + '">City/Town*</label> <small class="label-error" for="EmployersCity"></small>' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '].EmployersCity" id="EmployersCity" maxlength="50" class="form-control address-finder-details-city js-validate-check" autocomplete = "off" required data-msg-required = "A city or town is required">' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24 col-sm-12">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_employers_postcode_' + instanceNum + '">Postcode*</label> <small class="label-error" for="EmployersPostcode"></small>' +
            '<input type="text" name="StepTwo.Employers[' + instanceNum + '].EmployersPostcode" id="EmployersPostcode" class="form-control address-finder-details-postcode js-validate-check" maxlength = "8" autocomplete = "off" required data-msg-required = "A postcode is required">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $('.js-employer-details').append(html);
    }

    if ($('.employer-details').length === 0) {
        cloneEmployer();
    }

    $(document).on('change', '.js-on-change-employer-clone', function (e) {
        e.preventDefault();
        var months = 0;
        var requiredMonths = 36;
        var cloneRequired = true;

        $('.js-on-change-employer-clone').each(function () {
            if (months < requiredMonths) {
                var value = Number($(this).val());
                if ($(this).data('type') === 'years') {
                    var thisMonths = parseInt(value * 12);
                    months = parseInt(months + thisMonths);
                }
                else {
                    months = parseInt(months + value);
                }

                if (months >= requiredMonths) {
                    cloneRequired = false;
                }
                else {
                    cloneRequired = true;
                }
            }
            else {
                cloneRequired = false;
                if ($(this).data('type') === 'years') {
                    $(this).parents('.employer-details').remove();
                }
            }
        });
        var last = $(this).closest('.employer-details').siblings('.employer-details:visible').last();
        if (cloneRequired === true && last.find('#EmploymentYears').val() !== "" && last.find('#EmploymentMonths').val() !== "") {
            cloneEmployer();
        }
    });

    $(document).on('change', '.js-toggle-job-details', function (e) {
        var value = $(this).val();
        $employerDetails = $(this).parents('.employer-details');
        $jobDetails = $employerDetails.find('.employer-job-details');

        if (value === 'Permanent (Full Time)' || value === 'Permanent (Part Time)' || value === 'Temporary (Full Time)' || value === 'Self Employed') {
            $jobDetails.slideDown();
        }
        else {
            $jobDetails.slideUp();
        }
    });

    $(document).on('change keyup', '.js-credit-card-payments', function (e) {
        $('.credit-cards-yes').prop('checked', true);
        $('.credit-cards-no').prop('checked', false);
        $('.credit-cards-yes').trigger('change');
    });

    $(document).on('change', '#StepTwo_CompanyVatRegistered', function (e) {
        var value = $(this).val();
        var vatField = $('.js-show-if-company-is-vat-registered');
        if (value === "1" || value === true || $(this).val() === "True") {
            vatField.slideDown();
        }
        else {
            vatField.slideUp();
        }
    });

    $(document).on('change', '#StepTwo_SameAsRegisteredAddress', function (e) {
        var value = $(this).val();
        var vatField = $('.registered-address');
        if (value === "0" || value === false || $(this).val() !== "True") {
            vatField.slideDown();
        }
        else {
            vatField.slideUp();
        }
    });

    $(document).on('change', '.js-toggle-directors', function (e) {
        var value = $(this).val();
        
        setDirectorFields(value);
    });
    
    if (document.querySelectorAll('.js-toggle-directors').length > 0 && (document.querySelectorAll('#AdminMode').length == 0 || document.querySelector('#AdminMode').value == "False")){
        setDirectorFields(document.querySelector('.js-toggle-directors').value);
    }

    $(document).on('change', '.js-toggle-directors-by-num', function (e) {
        var value = $(this).val();
        var company = $('#StepOne_BusinessType').val();
        if (company === 'Partnership 4+' || company === 'LLP' || company === 'Limited Company' || company === 'PLC' || company === 'Partnership <4') {
            addNewDirectors(value, false);
        }
    });

    function addNewDirectors(quantity, removeValidation) {
        $(".js-directors .director-details").each(function () {
            $(this).remove();
        });
        for (i = 0; i < quantity; i++) {
            if (removeValidation && i === 0){
                cloneDirector(false);
            }
            else {
                cloneDirector(removeValidation);
            }
        }
    }

    function cloneDirector(removeValidation) {
        var instanceNum = parseInt($('.director-details').length);
        var dayOptions = '<option value="">Day</option>';
        var day;
        for (day = 1; day <= 31; day++) {
            dayOptions += '<option value="' + day + '">' + day + '</option>';
        }

        var yearOptions = '<option value="">Year</option>';
        var date = new Date();
        var year;

        for (year = date.getFullYear(); year >= date.getFullYear() - 90; year--) {
            yearOptions += '<option value="' + year + '">' + year + '</option>';
        }

        var html = '<div class="form-section director-details" data-number="' + instanceNum + '">' +
            '<h2 class="form-section-heading"><a href="#" class="form-section-link js-toggle-form-section">Company Director / Partner / Owner Details <span class="tooltip" data-content="Please complete the details of legal directors of the company. The number of directors&apos; details required depends on the business type.">?</span> <span class="form-section-link-icon icon-chevron-down"></span></a></h2>' +
            '<div class="form-section-content">' +
            '<div class="row">' +

            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_owner_title">Title' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_owner_title"></small>' +
            '<select name="StepTwo.Owners[' + instanceNum + '].Title" id="form_owner_title" class="form-control"' + (removeValidation === true ? '' : ' required data-msg-required = "Title is required"') + '>' +
            '<option value="">Please choose</option>' +
            '<option value="Mr">Mr</option>' +
            '<option value="Mrs">Mrs</option>' +
            '<option value="Miss">Miss</option>' +
            '<option value="Ms">Ms</option>' +
            '<option value="Doctor">Doctor</option>' +
            '<option value="Professor">Professor</option>' +
            '<option value="Rev">Rev</option>' +
            '<option value="Sir">Sir</option>' +
            '<option value="Other">Other</option>' +
            '</select>' +
            '</div>' +
            '</div>' +

            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_first_name">First Name' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_first_name"></small>' +
            '<input type="text" name="StepTwo.Owners[' + instanceNum + '].FirstName" id="form_first_name" maxlength="100" class="form-control js-validate-check" autocomplete="off" ' + (removeValidation === true ? '' : 'required data-msg-required = "First name is required"') + '>' +
            '</div>' +
            '</div>' +

            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_surname">Surname' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_surname"></small>' +
            '<input type="text" name="StepTwo.Owners[' + instanceNum + '].LastName" id="form_surname" maxlength="100" class="form-control js-validate-check" autocomplete="off" ' + (removeValidation === true ? '' : 'required data-msg-required = "Surname is required"') + '>' +
            '</div>' +
            '</div>' +

            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_email_address">Email Address' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_email_address"></small>' +
            '<input type="email" name="StepTwo.Owners[' + instanceNum + '].Email" id="form_email_address" maxlength="100" class="form-control js-validate-check" autocomplete="off" ' + (removeValidation === true ? '' : 'required data-msg-required = "Email Address is required"') + '>' +
            '</div>' +
            '</div>' +

            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_telephone">Telephone' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_telephone"></small>' +
            '<input name="StepTwo.Owners[' + instanceNum + '].ContactNumber" id="form_telephone" class="form-control js-validate-check" type = "tel" minlength = "10" maxlength = "13" autocomplete="off" ' + (removeValidation === true ? '' : 'required data-msg-required = "Telephone number is required"') + '>' +
            '</div>' +
            '</div>' +

            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_dob_day">Date of Birth' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_dob_day"></small>  <small class="label-error" for="form_dob_month"></small>  <small class="label-error" for="form_dob_year"></small>' +
            '<div class="row">' +
            '<div class="col-xs-8">' +
            '<select name="StepTwo.Owners[' + instanceNum + '].BirthDateDay" id="form_dob_day" class="form-control js-validate-check" data-rule-datesegments data-type="day" ' + (removeValidation === true ? '' : 'required data-msg-required = "A day is required"') + '>' + dayOptions + '</select>' +
            '</div>' +
            '<div class="col-xs-8">' +
            '<select name="StepTwo.Owners[' + instanceNum + '].BirthDateMonth" id="form_dob_month" class="form-control js-validate-check" data-type="month" ' + (removeValidation === true ? '' : ' required data-msg-required = "A month is required"') + '>' +
            '<option value="">Month</option>' +
            '<option value="1">January</option>' +
            '<option value="2">February</option>' +
            '<option value="3">March</option>' +
            '<option value="4">April</option>' +
            '<option value="5">May</option>' +
            '<option value="6">June</option>' +
            '<option value="7">July</option>' +
            '<option value="8">August</option>' +
            '<option value="9">September</option>' +
            '<option value="10">October</option>' +
            '<option value="11">November</option>' +
            '<option value="12">December</option>' +
            '</select>' +
            '</div>' +
            '<div class="col-xs-8">' +
            '<select name="StepTwo.Owners[' + instanceNum + '].BirthDateYear" id="form_dob_year" class="form-control js-validate-check"  data-type="year" ' + (removeValidation === true ? '' : ' required data-msg-required = "A year is required"') + '>' + yearOptions + '</select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_dependants">No. of Dependents' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_dependants"></small>' +
            '<select name="StepTwo.Owners[' + instanceNum + '].Dependants" id="form_dependants" class="form-control"' + (removeValidation === true ? '' : ' required data-msg-required="Number of dependants is required"') + '>' +
            '<option value="">Please choose</option>' +
            '<option value="0">0</option>' +
            '<option value="1">1</option>' +
            '<option value="2">2</option>' +
            '<option value="3">3</option>' +
            '<option value="4">4</option>' +
            '<option value="5">5</option>' +
            '<option value="6">6+</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="form-group">' +
            '<label class="response-label" for="form_marital_status">Marital Status' + (removeValidation === true ? '' : '*') + '</label> <small class="label-error" for="form_marital_status"></small>' +
            '<select name="StepTwo.Owners[' + instanceNum + '].MaritalStatus" id="form_marital_status" class="form-control"' + (removeValidation === true ? '' : ' required data-msg-required="Marital Status is required"') + '>' +
            '<option value="">Please choose</option>' +
            '<option value="Married">Married</option>' +
            '<option value="Single">Single</option>' +
            '<option value="Living with Partner">Living with Partner</option>' +
            '<option value="Divorced">Divorced</option>' +
            '<option value="Widowed">Widowed</option>' +
            '<option value="Separated">Separated</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<h3 class="no-top-margin">Address</h3>' +
            '</div>' +
            '<div class="col-xs-24">' +
            '<div class="js-address-details" data-name-prefix="StepTwo.Owners[' + instanceNum + '].OwnerAddresses"></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $('.js-directors').append(html);
        $('.js-address-details').each(function () {
            var $this = $(this);
            if ($this.is(':empty')) {
                var addressHtml = generateOwnerAddressHtml($this, removeValidation, instanceNum);
                $this.append(addressHtml);
            }
        });

    }
    
    function setDirectorFields(value){
        if (value === 'Sole Trader' || value === 'Partnership <4') {
            $('.income-section').removeClass('hidden');
            $('#income-summary').removeClass('hidden');
        }
        else {
            $('.income-section').addClass('hidden');
            $('#income-summary').addClass('hidden');
        }

        if (value === 'Sole Trader') {
            addNewDirectors(1, false);
        }
        else if (value === 'Partnership 4+' || value === 'LLP' || value === 'Limited Company' || value === 'PLC' || value === 'Partnership <4') {
            if (value === 'Limited Company') {
                addNewDirectors(2, true);
            } else {
                addNewDirectors(2, false);
            }
        }

        if (value === 'Partnership <4') {
            $('.directors-num-field').slideDown();
        }
        else {
            $('.directors-num-field').slideUp();
        }
    }
});